import { ButtonPrimary, ButtonSecondary } from "@nova/component-btn"
import { Licenses } from "@nova/constants"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ModalNames } from "features/modals/types"
import { useAppDispatch } from "integrations/redux/hooks"
import { useMemo, useCallback } from "react"
import * as Icons from "@nova/component-icons"
import { LicenseBadge } from "@nova/ds-component-license-badge"
import { showGlobalModal } from "runlevel/actions"
import { SupportButton } from "panels/routing/SettingsRoutes"
import { useLicensesAndAddonsTableData } from "./useLicensesAndAddonsTableData"
import { LicensesTable } from "./LicensesTable"
import { getGenericWorkspacePage } from "panels/routing/WorkspaceRoutes"

export const LicensesAndAddOnsSettingsPage = getGenericWorkspacePage({
    Header: LicensesSettingsHeader,
    Content: LicensesSettingsContent,
})

function LicensesSettingsHeader() {
    const dispatch = useAppDispatch()
    const tableData = useLicensesAndAddonsTableData()
    const counts = useMemo(() => {
        return tableData.reduce(
            (acc, cur) => {
                if (Object.keys(acc).includes(cur.license?.licenseType as string)) {
                    acc[cur.license?.licenseType as keyof typeof acc] += 1
                }
                return acc
            },
            { [Licenses.Pro]: 0, [Licenses.Essentials]: 0 }
        )
    }, [tableData])
    const showActivateKeyModal = useCallback(() => {
        dispatch(initializeCenterModalForComponentAction(ModalNames.ActivateKeyModal))
        dispatch(showGlobalModal())
    }, [dispatch])
    const showSubscriptionsModal = useCallback(() => {
        dispatch(initializeCenterModalForComponentAction(ModalNames.LicenseCheckoutModal))
        dispatch(showGlobalModal())
    }, [dispatch])
    return (
        <div className="w-full h-full flex items-center gap-6">
            <div className="text-[1.375rem] telegraf">Licenses & Add-ons</div>
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                    <div>{counts[Licenses.Pro]}</div>
                    <LicenseBadge license={Licenses.Pro} />
                </div>
                <div className="flex items-center gap-1">
                    <div>{counts[Licenses.Essentials]}</div>
                    <LicenseBadge license={Licenses.Essentials} />
                </div>
            </div>
            <div className="grow" />
            <div className="flex items-center gap-2">
                <SupportButton />
                <ButtonSecondary
                    title="Activate Key"
                    RightIcon={Icons.Key}
                    onClick={showActivateKeyModal}
                />
                <ButtonPrimary
                    title="Explore Subscriptions"
                    LeftIcon={Icons.Plus}
                    onClick={showSubscriptionsModal}
                />
            </div>
        </div>
    )
}

function LicensesSettingsContent() {
    return <LicensesTable />
}
